import React from "react";
import { HStack, Text, VStack } from "@chakra-ui/react";

const LocationList = ({ data, onSelectHouse }) => {
  const handleClick = () => {
    const lat = parseFloat(data.latitude);
    const lng = parseFloat(data.longitude);
    onSelectHouse(lat, lng);
  };

  return (
    <VStack
      transition="ease-in-out .3s"
      w="full"
      bg="#fff"
      roundedTopRight="md"
      roundedBottomRight="md"
      shadow="md"
      py="2"
      px="4"
      align="flex-start"
      spacing={2}
      borderLeftWidth="medium"
      borderLeftColor="#45A735"
      _hover={{ shadow: "lg" }}
      cursor="pointer"
      onClick={handleClick}
    >
      <VStack align="flex-start" spacing={0}>
        <Text fontWeight="medium" fontSize="15">
          {data?.username}
        </Text>
        <Text fontSize="13">{data?.houseName}</Text>
        {data?.description && (
          <Text fontSize="13" color={"#000"}>
            Тайлбар: {data?.description}
          </Text>
        )}
      </VStack>
      <HStack
        w="full"
        bg="#eee"
        rounded="sm"
        px="4"
        py={"1"}
        justify="space-between"
      >
        <Text fontSize="13">Төхөөрөмжийн тоо:</Text>
        <Text fontWeight="medium" fontSize="13">
          {data?.deviceCount}
        </Text>
      </HStack>
    </VStack>
  );
};

export default LocationList;
